module.exports = __webpack_public_path__ + "img/ots.4a9a4790.png";